module.exports = __webpack_public_path__ + "static/media/iconoir_privacy_policy.adcbc500.svg";